<template>
  <el-dialog title="Lagerbewegungen" :visible="show" @close="$emit('close')">
    <div class="row">
      <div class="col-sm-12">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Datum</th>
              <th>User</th>
              <th>Menge</th>
              <th>Grund</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="stockRotation in stockRotations" :key="stockRotation.id">
              <td>{{ stockRotation.created_at | date }}</td>
              <td v-text="stockRotation.user.name"></td>
              <td class="text-right"
                :class="stockRotation.cause.direction !== 0 ? (stockRotation.quantity * stockRotation.cause.direction > 0 ? 'rotation-in' : 'rotation-out') : ''"
              >
                <span v-if="stockRotation.quantity * stockRotation.cause.direction > 0">+</span>{{ stockRotation.cause.direction !== 0 ? (stockRotation.quantity * stockRotation.cause.direction) : stockRotation.quantity }}
              </td>
              <td>{{ stockRotation.cause.name }}</td>
            </tr>
          </tbody>
        </table>
        <br>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'

export default {
  components: { [Dialog.name]: Dialog },
  props: ['show', 'stockRotations']
}
</script>

<style>
</style>
